import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtensionBasicInfoQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionBasicInfoQuery = { __typename?: 'Query', userBasicInfo?: { __typename?: 'UserBasicInfo', shortNumber?: string | null, e164?: string | null, displayName?: string | null, devicesClient?: number | null, devicesLinked?: number | null, devicesProvisioned?: number | null, devicesThirdparty?: number | null, devicesClientNotRegistered?: number | null, devicesLinkedNotRegistered?: number | null, devicesProvisionedNotRegistered?: number | null, devicesThirdpartyNotRegistered?: number | null } | null };

export type UpdateExtensionMutationVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
  data: Types.UpdateUserData;
}>;


export type UpdateExtensionMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserResult', devicesToResync?: Array<number> | null, errors?: Array<{ __typename?: 'Error', location: Array<string>, context?: string | null, type: string }> | null } | null };

export type GroupListFragment = { __typename?: 'Group', name: string, id: number };

export type ResyncProvisionedDeviceMutationVariables = Types.Exact<{
  deviceIdList: Array<Types.Scalars['Int']['input']>;
}>;


export type ResyncProvisionedDeviceMutation = { __typename?: 'Mutation', resynchronizeProvisionedDevices: { __typename?: 'DeviceResynchronizeResult', error?: Types.ResynchronizeError | null, devices: Array<{ __typename?: 'DeviceResynchronizeStatus', id?: number | null, error?: Types.CallControlCommandError | null }> } };

export const GroupListFragmentDoc = gql`
    fragment GroupList on Group {
  name
  id
}
    `;
export const ExtensionBasicInfoDocument = gql`
    query ExtensionBasicInfo($userId: Int!) {
  userBasicInfo(userId: $userId) {
    shortNumber
    e164
    displayName
    devicesClient
    devicesLinked
    devicesProvisioned
    devicesThirdparty
    devicesClientNotRegistered
    devicesLinkedNotRegistered
    devicesProvisionedNotRegistered
    devicesThirdpartyNotRegistered
  }
}
    `;

/**
 * __useExtensionBasicInfoQuery__
 *
 * To run a query within a React component, call `useExtensionBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionBasicInfoQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables> & ({ variables: ExtensionBasicInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>(ExtensionBasicInfoDocument, options);
      }
export function useExtensionBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>(ExtensionBasicInfoDocument, options);
        }
export function useExtensionBasicInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>(ExtensionBasicInfoDocument, options);
        }
export type ExtensionBasicInfoQueryHookResult = ReturnType<typeof useExtensionBasicInfoQuery>;
export type ExtensionBasicInfoLazyQueryHookResult = ReturnType<typeof useExtensionBasicInfoLazyQuery>;
export type ExtensionBasicInfoSuspenseQueryHookResult = ReturnType<typeof useExtensionBasicInfoSuspenseQuery>;
export type ExtensionBasicInfoQueryResult = Apollo.QueryResult<ExtensionBasicInfoQuery, ExtensionBasicInfoQueryVariables>;
export const UpdateExtensionDocument = gql`
    mutation UpdateExtension($id: Int!, $data: UpdateUserData!) {
  updateUser(id: $id, data: $data) {
    errors {
      location
      context
      type
    }
    devicesToResync
  }
}
    `;
export type UpdateExtensionMutationFn = Apollo.MutationFunction<UpdateExtensionMutation, UpdateExtensionMutationVariables>;

/**
 * __useUpdateExtensionMutation__
 *
 * To run a mutation, you first call `useUpdateExtensionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExtensionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExtensionMutation, { data, loading, error }] = useUpdateExtensionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateExtensionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExtensionMutation, UpdateExtensionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExtensionMutation, UpdateExtensionMutationVariables>(UpdateExtensionDocument, options);
      }
export type UpdateExtensionMutationHookResult = ReturnType<typeof useUpdateExtensionMutation>;
export type UpdateExtensionMutationResult = Apollo.MutationResult<UpdateExtensionMutation>;
export type UpdateExtensionMutationOptions = Apollo.BaseMutationOptions<UpdateExtensionMutation, UpdateExtensionMutationVariables>;
export const ResyncProvisionedDeviceDocument = gql`
    mutation ResyncProvisionedDevice($deviceIdList: [Int!]!) {
  resynchronizeProvisionedDevices(deviceIdList: $deviceIdList) {
    error
    devices {
      id
      error
    }
  }
}
    `;
export type ResyncProvisionedDeviceMutationFn = Apollo.MutationFunction<ResyncProvisionedDeviceMutation, ResyncProvisionedDeviceMutationVariables>;

/**
 * __useResyncProvisionedDeviceMutation__
 *
 * To run a mutation, you first call `useResyncProvisionedDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResyncProvisionedDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resyncProvisionedDeviceMutation, { data, loading, error }] = useResyncProvisionedDeviceMutation({
 *   variables: {
 *      deviceIdList: // value for 'deviceIdList'
 *   },
 * });
 */
export function useResyncProvisionedDeviceMutation(baseOptions?: Apollo.MutationHookOptions<ResyncProvisionedDeviceMutation, ResyncProvisionedDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResyncProvisionedDeviceMutation, ResyncProvisionedDeviceMutationVariables>(ResyncProvisionedDeviceDocument, options);
      }
export type ResyncProvisionedDeviceMutationHookResult = ReturnType<typeof useResyncProvisionedDeviceMutation>;
export type ResyncProvisionedDeviceMutationResult = Apollo.MutationResult<ResyncProvisionedDeviceMutation>;
export type ResyncProvisionedDeviceMutationOptions = Apollo.BaseMutationOptions<ResyncProvisionedDeviceMutation, ResyncProvisionedDeviceMutationVariables>;